<template>
  <b-dropdown-item
    @click.stop.prevent="httpRequest"
    :variant="secondaryVariant"
  >
  Pcap Fetch
  </b-dropdown-item>
</template>

<script>

export default {
  props: {
    pcapFilename: {
      type: String,
      required: true,
    },
  },
  computed: {
    getPcapDownloadUrl() {
      return `/pcap/file/download?filePath=${encodeURIComponent(this.pcapFilename)}`;
    },
  },
  methods: {
    async httpRequest() {
      try {
        const response = await fetch(this.getPcapDownloadUrl);

        if (!response.ok) {
          this.$bvToast.toast('PCAP is not available right now.', {
            title: 'Download failed',
            variant: 'danger',
          });
          return;
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        const filename = this.pcapFilename;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (e) {
        this.$bvToast.toast('Network error occurred during PCAP download.', {
          title: 'Download failed',
          variant: 'danger',
        });
      }
    },
  },
};
</script>
